import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class GenesysService {
  private readonly genesysName: string = 'Genesys';
  private readonly genesysScriptUrl: string = 'https://apps.mypurecloud.de/genesys-bootstrap/genesys.min.js';
  private readonly genesysEnvironment: string = 'prod-euc1';
  private readonly genesysDeploymentId: string = 'b9dcd9a4-5d2c-42ee-bfdc-641e43f9c838';

  public genesysScriptLoaded(document: Document): boolean {
    return Array.from(document.head.getElementsByTagName('script')).some(
      (script) => script.src === this.genesysScriptUrl,
    );
  }

  public loadGenesysScript(): void {
    // @ts-ignore
    window['_genesysJs'] = this.genesysName;
    // @ts-ignore
    window[this.genesysName] =
      // @ts-ignore
      window[this.genesysName] ||
      function () {
        // @ts-ignore
        (window[this.genesysName].q = window[this.genesysName].q || []).push(arguments);
      };
    // @ts-ignore
    window[this.genesysName].t = 1 * new Date();
    // @ts-ignore
    window[this.genesysName].c = {
      environment: this.genesysEnvironment,
      deploymentId: this.genesysDeploymentId,
    };

    let genesysScriptElement: HTMLScriptElement = document.createElement('script');
    genesysScriptElement.async = true;
    genesysScriptElement.src = this.genesysScriptUrl;
    document.head.appendChild(genesysScriptElement);
  }
}
